import { ShieldAlert, ShieldCheck, ShieldOff, ShieldX } from 'lucide-react'

import { warrantyStatus } from '@/lib/format'
import { cn } from '@/lib/utils'

interface WarrantyBadgeProps {
	expiresAt: Date | string | null
	className?: string
}

export function WarrantyBadge({ expiresAt, className }: WarrantyBadgeProps) {
	const status = warrantyStatus(expiresAt)

	const base =
		'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium'

	if (status.kind === 'none') {
		return (
			<span
				className={cn(
					base,
					'bg-muted text-muted-foreground tabular-nums',
					className,
				)}
			>
				<ShieldOff className="size-3.5" />
				No warranty
			</span>
		)
	}

	if (status.kind === 'expired') {
		return (
			<span
				className={cn(
					base,
					'bg-status-expired/10 text-status-expired tabular-nums',
					className,
				)}
			>
				<ShieldX className="size-3.5" />
				Expired {status.daysAgo}d ago
			</span>
		)
	}

	if (status.kind === 'expiring') {
		return (
			<span
				className={cn(
					base,
					'bg-status-warning/15 text-status-warning tabular-nums',
					className,
				)}
			>
				<ShieldAlert className="size-3.5" />
				{status.daysLeft === 0 ? 'Expires today' : `${status.daysLeft}d left`}
			</span>
		)
	}

	return (
		<span
			className={cn(
				base,
				'bg-status-ok/12 text-status-ok tabular-nums',
				className,
			)}
		>
			<ShieldCheck className="size-3.5" />
			{status.monthsLeft >= 1
				? `${status.monthsLeft} mo left`
				: `${status.daysLeft}d left`}
		</span>
	)
}
